import React from 'react';

const SubmittedSheetsEmployee = () => {
    return (
        <div className="submitted-sheets-container">
            <div className="content-section">
            <h3 style={{ fontSize: "20px", fontWeight: "400", color: "#000000", marginTop: "20px", marginBottom: "10px" }}>
            What happens After I Submit a Timesheet?
                </h3>
                
                <p className="description">
                    Once your timesheet is submitted, it is sent for approval. You will receive a confirmation via email and a notification within the system.
                </p>

                <h4 className="sub-heading">How to Check Your Submitted Timesheets?</h4>
                <p className="description">
                    <li> You can track your submitted timesheets in the "Pending Sheets" section.  </li>
                    <li> If you saved a timesheet but didn’t submit it, it will appear under "Saved Drafts.</li>  
                    <li>Approved timesheets will be locked and cannot be edited. If changes are needed, contact your manager.</li>  
                </p>

                <h4 className="sub-heading">Steps to Submit Your Timesheet</h4>
                <ol className="steps-list">
                    <li>Go to the "Timesheet" section.</li>
                    <li>Select the project and open your timesheet.</li>
                    <li>Enter your billable hours for the week.</li>
                    <li>Attach any required documents.</li>
                    <li>Click "Submit" to finalize the process.</li>
                </ol>

                <img
                    className="submitted-image"
                    src="https://res.cloudinary.com/danfpnuui/image/upload/v1737352284/Submitted_sheets-1_n9ch9g.png"
                    alt="Timesheet Submission Process"
                />

                <h4 className="sub-heading">Important Notes</h4>
                <p className="description">
                    <li>If you realize an error "after submission," contact your manager immediately. </li> 
                    <li> Submitting accurate timesheets helps avoid payment delays.  </li>
                    <li> Ensure all required attachments are uploaded before submission. </li> 
                </p>
            </div>

            <style jsx>{`
                .submitted-sheets-container {
                    padding: 20px;
                    font-family: Arial, sans-serif;
                }

                .heading {
                    font-size: 22px;
                    font-weight: bold;
                    color: #000;
                    margin-bottom: 15px;
                }

                .sub-heading {
                    font-size: 18px;
                    font-weight: bold;
                    color: #333;
                    margin-top: 20px;
                    margin-bottom: 10px;
                }

                .description {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                    margin-bottom: 15px;
                }

                .steps-list {
                    padding-left: 20px;
                    font-size: 16px;
                    line-height: 1.6;
                }

                .steps-list li {
                    margin-bottom: 10px;
                }

                .submitted-image {
                    display: block;
                    width: 70%;
                    max-width: 500px;
                    height: auto;
                    margin: 20px auto;
                    border-radius: 5px;
                }

                @media (max-width: 768px) {
                    .heading {
                        font-size: 20px;
                    }

                    .sub-heading {
                        font-size: 16px;
                    }

                    .description,
                    .steps-list {
                        font-size: 14px;
                    }

                    .submitted-image {
                        width: 90%;
                    }
                }

                @media (max-width: 480px) {
                    .heading {
                        font-size: 18px;
                    }

                    .sub-heading {
                        font-size: 14px;
                    }

                    .description,
                    .steps-list {
                        font-size: 12px;
                    }

                    .submitted-image {
                        width: 100%;
                    }
                }
            `}</style>
        </div>
    );
};

export default SubmittedSheetsEmployee;
